/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Mark_DoneInputs */

const en_session_mark_done = /** @type {(inputs: Session_Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as cooked`)
};

const de_session_mark_done = /** @type {(inputs: Session_Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als gekocht markieren`)
};

/**
* | output |
* | --- |
* | "Mark as cooked" |
*
* @param {Session_Mark_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_mark_done = /** @type {((inputs?: Session_Mark_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Mark_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_mark_done(inputs)
	return en_session_mark_done(inputs)
});